<template>
  <div>
    <!--    <div v-if="-->
    <!--            user &&-->
    <!--            $route.path !== '/' &&-->
    <!--            $route.path !== '/blog' &&-->
    <!--            $route.path !== '/contact-us' &&-->
    <!--            $route.path !== '/about-us'"-->
    <!--    >-->
    <!--      <v-btn text @click="drawer = !drawer">-->
    <!--        <v-icon color="#19b39a">mdi-menu</v-icon>-->
    <!--      </v-btn>-->
    <!--      <v-navigation-drawer-->
    <!--          class="navigation-main"-->
    <!--          width="70vw"-->
    <!--          right-->
    <!--          fixed-->
    <!--          v-model="drawer"-->
    <!--          flat-->
    <!--      >-->
    <!--        <v-list-->
    <!--            nav-->
    <!--        >-->
    <!--          &lt;!&ndash;        PROFILE&ndash;&gt;-->
    <!--          <v-list-item @click="$router.push('/dashboard/profile')">-->
    <!--            <v-list-item-icon>-->
    <!--              <v-btn fab class="pa-1" color="#ffe1ae" elevation="0">-->
    <!--                <img height="100%" width="40px" v-if="user.gender === 'male'"-->
    <!--                     src="@/assets/man.png" alt="man profile picture">-->
    <!--                <img height="100%" width="40px" v-else src="@/assets/woman.png"-->
    <!--                     alt="woman profile picture">-->
    <!--              </v-btn>-->
    <!--            </v-list-item-icon>-->
    <!--            <v-list-item-title class="py-2">-->
    <!--              <div class="title-dashboard-sections">-->
    <!--                {{ user.name }}-->
    <!--                <v-icon @click="logout" large color="#ff7272" class="mr-2">mdi-logout</v-icon>-->
    <!--              </div>-->
    <!--            </v-list-item-title>-->
    <!--          </v-list-item>-->
    <!--          &lt;!&ndash;        DASHBOARD&ndash;&gt;-->
    <!--          <v-list-item @click="$router.push('/dashboard')">-->
    <!--            <v-list-item-icon>-->
    <!--              <v-btn fab color="#FFAB91" elevation="0">-->
    <!--                <v-icon large color="white">mdi-view-dashboard-outline</v-icon>-->
    <!--              </v-btn>-->
    <!--            </v-list-item-icon>-->
    <!--            <v-list-item-content>-->
    <!--              <v-list-item-title class="title-dashboard-sections">-->
    <!--                پیشخوان-->
    <!--                <v-icon color="white">mdi-chevron-left</v-icon>-->
    <!--              </v-list-item-title>-->
    <!--            </v-list-item-content>-->
    <!--          </v-list-item>-->
    <!--          &lt;!&ndash;        courses&ndash;&gt;-->
    <!--          <v-list-item @click="$router.push('/dashboard/my-courses')">-->
    <!--            <v-list-item-icon>-->
    <!--              <v-btn fab color="#f7be45" elevation="0">-->
    <!--                <v-icon color="white" large>mdi-bookshelf</v-icon>-->
    <!--              </v-btn>-->
    <!--            </v-list-item-icon>-->
    <!--            <v-list-item-content>-->
    <!--              <v-list-item-title class="title-dashboard-sections">درس ها-->
    <!--                <v-icon color="white">mdi-chevron-left</v-icon>-->
    <!--                &emsp;&emsp;&emsp;-->
    <!--                <v-icon v-if="user.not_seen_messages" color="white">mdi-email</v-icon>-->
    <!--                <span v-if="user.not_seen_messages">-->
    <!--                {{ user.not_seen_messages }}-->
    <!--              </span>-->
    <!--                <v-icon v-if="user.not_seen_files" color="white">mdi-paperclip</v-icon>-->
    <!--                <span v-if="user.not_seen_files">-->
    <!--                {{ user.not_seen_files }}-->
    <!--              </span>-->
    <!--              </v-list-item-title>-->
    <!--            </v-list-item-content>-->
    <!--          </v-list-item>-->
    <!--          &lt;!&ndash; online Sessions &ndash;&gt;-->
    <!--          <v-list-item @click="$router.push('/dashboard/online-sessions')">-->
    <!--            <v-list-item-icon>-->
    <!--              <v-btn fab color="#4c8bde" elevation="0">-->
    <!--                <v-icon color="white" large>mdi-monitor</v-icon>-->
    <!--              </v-btn>-->
    <!--            </v-list-item-icon>-->
    <!--            <v-list-item-content>-->
    <!--              <v-list-item-title class="title-dashboard-sections">-->
    <!--                جلسات آنلاین-->
    <!--                <v-icon color="white">mdi-chevron-left</v-icon>-->
    <!--              </v-list-item-title>-->
    <!--            </v-list-item-content>-->
    <!--          </v-list-item>-->

    <!--          &lt;!&ndash; About course and instructor &ndash;&gt;-->
    <!--          <v-list-item @click="$router.push('/dashboard/about/courses-instructors')">-->
    <!--            <v-list-item-icon>-->
    <!--              <v-btn fab color="#93c75a" elevation="0">-->
    <!--                <v-icon color="white" large>mdi-book-open-variant</v-icon>-->
    <!--              </v-btn>-->
    <!--            </v-list-item-icon>-->
    <!--            <v-list-item-content>-->
    <!--              <v-list-item-title class="title-dashboard-sections">-->
    <!--                درباره دوره و مربی-->
    <!--                <v-icon color="white">mdi-chevron-left</v-icon>-->
    <!--              </v-list-item-title>-->
    <!--            </v-list-item-content>-->
    <!--          </v-list-item>-->
    <!--          &lt;!&ndash; Result &ndash;&gt;-->
    <!--          <v-list-item @click="$router.push('/dashboard/assessments')">-->
    <!--            <v-list-item-icon>-->
    <!--              <v-btn fab color="#91c1c0" elevation="0">-->
    <!--                <v-icon color="white" large>mdi-clipboard-check-outline</v-icon>-->
    <!--              </v-btn>-->
    <!--            </v-list-item-icon>-->
    <!--            <v-list-item-content>-->
    <!--              <v-list-item-title class="title-dashboard-sections">-->
    <!--                ارزیابی-->
    <!--                <v-icon color="white">mdi-chevron-left</v-icon>-->
    <!--              </v-list-item-title>-->
    <!--            </v-list-item-content>-->
    <!--          </v-list-item>-->
    <!--          &lt;!&ndash; Information &ndash;&gt;-->
    <!--          <v-list-item @click="$router.push('/dashboard/profile')">-->
    <!--            <v-list-item-icon>-->
    <!--              <v-btn fab color="#3dc3a2" elevation="0">-->
    <!--                <v-icon color="white" large>mdi-account-edit-outline</v-icon>-->
    <!--              </v-btn>-->
    <!--            </v-list-item-icon>-->
    <!--            <v-list-item-content>-->
    <!--              <v-list-item-title class="title-dashboard-sections">-->
    <!--                اطلاعات هنرجو-->
    <!--                <v-icon color="white">mdi-chevron-left</v-icon>-->
    <!--              </v-list-item-title>-->
    <!--            </v-list-item-content>-->
    <!--          </v-list-item>-->
    <!--          &lt;!&ndash; courses &ndash;&gt;-->
    <!--          <v-list-item @click="$router.push('/dashboard/courses')">-->
    <!--            <v-list-item-icon>-->
    <!--              <v-btn fab color="#de4756" elevation="0">-->
    <!--                <v-icon color="white" large>mdi-folder-multiple-outline</v-icon>-->
    <!--              </v-btn>-->
    <!--            </v-list-item-icon>-->
    <!--            <v-list-item-content>-->
    <!--              <v-list-item-title class="title-dashboard-sections">-->
    <!--                دوره ها-->
    <!--                <v-icon color="white">mdi-chevron-left</v-icon>-->
    <!--              </v-list-item-title>-->
    <!--            </v-list-item-content>-->
    <!--          </v-list-item>-->
    <!--          &lt;!&ndash; Notifications &ndash;&gt;-->
    <!--          <v-list-item @click="$router.push('/dashboard/notifications')">-->
    <!--            <v-list-item-icon>-->
    <!--              <v-btn fab color="teal" elevation="0">-->
    <!--                <v-badge :content="notifications.length" color="error">-->
    <!--                  <v-icon color="white" large>mdi-bell-outline</v-icon>-->
    <!--                </v-badge>-->
    <!--              </v-btn>-->
    <!--            </v-list-item-icon>-->
    <!--            <v-list-item-content>-->
    <!--              <v-list-item-title class="title-dashboard-sections">-->
    <!--                اعلان ها-->
    <!--                <v-icon color="white">mdi-chevron-left</v-icon>-->
    <!--              </v-list-item-title>-->
    <!--            </v-list-item-content>-->
    <!--          </v-list-item>-->
    <!--          &lt;!&ndash;        home&ndash;&gt;-->
    <!--          <v-list-item @click="$router.push('/')">-->
    <!--            <v-list-item-icon>-->
    <!--              <v-btn fab color="#9e82e1" elevation="0">-->
    <!--                <v-icon color="white" large>mdi-home-variant-outline</v-icon>-->
    <!--              </v-btn>-->
    <!--            </v-list-item-icon>-->
    <!--            <v-list-item-content>-->
    <!--              <v-list-item-title class="title-dashboard-sections">-->
    <!--                صفحه اصلی-->
    <!--                <v-icon color="white">mdi-chevron-left</v-icon>-->
    <!--              </v-list-item-title>-->
    <!--            </v-list-item-content>-->
    <!--          </v-list-item>-->
    <!--        </v-list>-->
    <!--      </v-navigation-drawer>-->
    <!--    </div>-->
    <div v-if="!user">
      <v-btn text @click="drawer = !drawer">
        <v-icon color="#19b39a">mdi-menu</v-icon>
      </v-btn>
      <v-navigation-drawer
          class="navigation-main"
          width="70vw"
          right
          fixed
          v-model="drawer"
          flat
      >
        <v-list
            nav
        >
          <!--        home-->
          <v-list-item @click="$router.push('/')">
            <v-list-item-icon>
              <v-btn fab color="#9e82e1" elevation="0">
                <v-icon color="white" large>mdi-home-variant-outline</v-icon>
              </v-btn>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="title-dashboard-sections">
                صفحه اصلی
                <v-icon color="white">mdi-chevron-left</v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!--        Login and register-->
          <v-list-item @click="$router.push('/login')">
            <v-list-item-icon>
              <v-btn fab color="teal" elevation="0">
                <v-icon color="white" large>mdi-account-arrow-left</v-icon>
              </v-btn>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="title-dashboard-sections">
                ورود
                <v-icon color="white">mdi-chevron-left</v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="$router.push('/register')">
            <v-list-item-icon>
              <v-btn fab color="blue" elevation="0">
                <v-icon color="white" large>mdi-account-plus</v-icon>
              </v-btn>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="title-dashboard-sections">
                ثبت نام
                <v-icon color="white">mdi-chevron-left</v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!--Blog-->
          <v-list-item @click="$router.push('/blog')">
            <v-list-item-icon>
              <v-btn fab color="warning" elevation="0">
                <v-icon color="white" large>mdi-text-box-outline</v-icon>
              </v-btn>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="title-dashboard-sections">
                بلاگ دُرَک
                <v-icon color="white">mdi-chevron-left</v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!--Help-->
          <v-list-item @click="$router.push('/help')">
            <v-list-item-icon>
              <v-btn fab color="error" elevation="0">
                <v-icon color="white" large>mdi-help-box-outline</v-icon>
              </v-btn>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="title-dashboard-sections">
                راهنمای دُرَک
                <v-icon color="white">mdi-chevron-left</v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <div class="footer-main">
        <v-row>
          <v-col class="pr-10" cols="4" @click="$router.push('/login')">
            <v-row class="my-0">
              <v-col cols="12" class="my-0 py-0 pr-9">
                <v-icon>
                  mdi-account-arrow-left
                </v-icon>
              </v-col>
              <v-col cols="12" style="font-size: 3vw" class="py-0 mr-6">
                ورود
              </v-col>
            </v-row>
          </v-col>
          <v-col class="text-center" cols="4" @click="$router.push('/')">
            <v-row class="my-0 ml-4">
              <v-col cols="12" class="ma-0 pa-0 text-center">
                <v-icon>
                  mdi-home
                </v-icon>
              </v-col>
              <v-col cols="12" style="font-size: 3vw" class="pa-0 ma-0 text-center">
                خانه
              </v-col>
            </v-row>
          </v-col>
          <v-col class="text-center" style="font-size: 3vw" cols="4" @click="$router.push('/register')">
            <v-row class="my-0">
              <v-col cols="12" class="my-0 py-0 pr-9">
                <v-icon>
                  mdi-account-arrow-left
                </v-icon>
              </v-col>
              <v-col cols="12" style="font-size: 3vw" class="py-0 mr-3">
                ثبت نام
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <!--      <v-btn class="mobile-menu-button" block color="#1ab69d" @click="drawer = !drawer">-->
      <!--        <v-icon class="mobile-menu-icon" color="white">mdi-chevron-double-down</v-icon>-->
      <!--      </v-btn>-->
      <!--      <v-navigation-drawer-->
      <!--          v-model="drawer"-->
      <!--          absolute-->
      <!--          bottom-->
      <!--          temporary-->
      <!--      >-->
      <!--        <v-list-->
      <!--            nav-->
      <!--            dense-->
      <!--        >-->
      <!--          <v-list-item-group-->
      <!--              v-model="group"-->
      <!--              active-class="down-menu-active"-->
      <!--          >-->
      <!--            <v-list-item>-->
      <!--              <v-list-item-title>-->
      <!--                <v-row>-->
      <!--                  <v-col cols="4" class="text-right">-->
      <!--                    <v-icon class="mt-2" color="error">mdi-login</v-icon>-->
      <!--                    <span class="mt-3">-->
      <!--                      خروج-->
      <!--                    </span>-->
      <!--                  </v-col>-->
      <!--                  <v-col class="text-center">-->
      <!--                    <v-btn v-if="!auth" text class="button-normal-black" @click="$router.push('/login-register')">-->
      <!--                      ورود/ثبت نام-->
      <!--                    </v-btn>-->
      <!--                    <v-btn v-else text class="button-normal-black" @click="$router.push('/dashboard')">-->
      <!--                      {{ user.name }}-->
      <!--                      <v-icon class="mt-2" color="#1ab69d" x-large>mdi-account-cog-outline</v-icon>-->
      <!--                    </v-btn>-->
      <!--                  </v-col>-->
      <!--                  <v-col class="mt-0 pt-0" cols="12">-->
      <!--                    <v-divider></v-divider>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--              </v-list-item-title>-->
      <!--            </v-list-item>-->


      <!--            <v-list-item>-->
      <!--              <v-list-item-title>-->
      <!--                <v-row>-->
      <!--                  <v-col cols="4">-->
      <!--                    <v-icon class="mt-2">mdi-information-variant</v-icon>&nbsp;&nbsp;-->
      <!--                  </v-col>-->
      <!--                  <v-col>-->
      <!--                    <v-btn text class="button-normal-black" @click="$router.push('/about-us')">-->
      <!--                      درباره ما-->
      <!--                    </v-btn>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->

      <!--              </v-list-item-title>-->
      <!--            </v-list-item>-->

      <!--            <v-list-item>-->
      <!--              <v-list-item-title>-->
      <!--                <v-row>-->
      <!--                  <v-col cols="4" class="text-right">-->
      <!--                    <v-icon class="mt-2">mdi-phone-outline</v-icon>-->
      <!--                  </v-col>-->
      <!--                  <v-col class="text-right">-->
      <!--                    <v-btn text class="button-normal-black" @click="$router.push('/contact-us')">-->
      <!--                      تماس با ما-->
      <!--                    </v-btn>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--              </v-list-item-title>-->
      <!--            </v-list-item>-->

      <!--            <v-list-item>-->
      <!--              <v-list-item-title>-->
      <!--                <v-row>-->
      <!--                  <v-col cols="4" class="text-right">-->
      <!--                    <v-icon class="mt-2">mdi-text-box-multiple-outline</v-icon>-->
      <!--                  </v-col>-->
      <!--                  <v-col>-->
      <!--                    <v-btn text class="button-normal-black" @click="$router.push('/blog')">-->
      <!--                      بلاگ-->
      <!--                    </v-btn>-->
      <!--                  </v-col>-->
      <!--                </v-row>-->
      <!--              </v-list-item-title>-->
      <!--            </v-list-item>-->
      <!--            <v-list-item>-->
      <!--              <v-list-item-title>-->
      <!--                <v-btn block color="#1ab69d" class="button-normal-white text-center">-->
      <!--                  رایگان امتحان کنید-->
      <!--                </v-btn>-->
      <!--              </v-list-item-title>-->
      <!--            </v-list-item>-->

      <!--            <v-list-item>-->
      <!--              <v-list-item-title>-->
      <!--                <img height="80px" class="dorakk-footer-home-logo-mobile" src="@/assets/dorakk-logo-2.png"-->
      <!--                     alt="dorakk">-->
      <!--              </v-list-item-title>-->
      <!--            </v-list-item>-->
      <!--          </v-list-item-group>-->
      <!--        </v-list>-->
      <!--      </v-navigation-drawer>-->
    </div>
    <div v-else>
      <div class="footer-main">
        <v-row class="footer-nav-row" no-gutters>
          <v-col class="footer-nav-item" @click="$router.push('/dashboard/notifications')">
            <v-row class="my-0" justify="center">
              <v-col cols="12" class="ma-0 pa-0 text-center">
                <v-badge :content="notifications.length" color="#1ab69d">
                  <v-icon>
                    mdi-bell
                  </v-icon>
                </v-badge>
              </v-col>
              <v-col cols="12" class="pa-0 ma-0 text-center">
                اعلان ها
              </v-col>
            </v-row>
          </v-col>
          <v-col class="footer-nav-item" @click="$router.push('/dashboard')">
            <v-row class="my-0" justify="center">
              <v-col cols="12" class="my-0 py-0 text-center">
                <v-icon>
                  mdi-account-details-outline
                </v-icon>
              </v-col>
              <v-col cols="12" class="py-0 my-0 text-center">
                پیشخوان
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="socialEnabled" class="footer-nav-item" @click="$router.push('/dashboard/social')">
            <v-row class="my-0" justify="center">
              <v-col cols="12" class="my-0 py-0 text-center"><v-icon>mdi-account-group-outline</v-icon></v-col>
              <v-col cols="12" class="py-0 my-0 text-center">جامعه</v-col>
            </v-row>
          </v-col>
          <v-col class="footer-nav-item" @click="$router.push('/dashboard/my-courses')">
            <v-row class="my-0" justify="center">
              <v-col cols="12" class="ma-0 pa-0 text-center">
                <v-icon>
                  mdi-bookshelf
                </v-icon>
              </v-col>
              <v-col cols="12" class="pa-0 ma-0 text-center">
                درس ها
              </v-col>
            </v-row>
          </v-col>
          <v-col class="footer-nav-item" @click="$router.push('/dashboard/subscriptions')">
            <v-row class="my-0" justify="center">
              <v-col cols="12" class="ma-0 pa-0 text-center">
                <v-icon>
                  mdi-card-account-details-outline
                </v-icon>
              </v-col>
              <v-col cols="12" class="pa-0 ma-0 text-center">
                اشتراک
              </v-col>
            </v-row>
          </v-col>
          <v-col class="footer-nav-item" @click="logout">
            <v-row class="my-0" justify="center">
              <v-col cols="12" class="ma-0 pa-0 text-center">
                <v-icon color="error">
                  mdi-logout
                </v-icon>
              </v-col>
              <v-col cols="12" class="pa-0 ma-0 text-center">
                خروج
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBarMobile",
  props: ['notifications'],
  data() {
    return {
      loading: true,
      drawer: false,
      group: null,
      user: null,
      auth: false,
      socialEnabled: false,
    }
  },
  mounted() {
    this.user = this.$store.state.user
    this.auth = this.$store.state.auth
    this.loading = this.$store.state.loading
    window.axios.get('student/social/status').then(res => { this.socialEnabled = !!res.data.enabled }).catch(() => { this.socialEnabled = false })
  },
  methods: {
    search() {

    },
    logout() {
      window.axios.post('/student/auth/logout')
      this.$cookies.remove('token')
      localStorage.removeItem('device_id')
      this.$router.go(0)
    }
  }
}
</script>

<style>
.footer-main {
  position: fixed;
  z-index: 5 !important;
  bottom: 0;
  height: 8vh !important;
  width: 100% !important;
  border-radius: 10px 10px 0 0 !important;
  background-color: white !important;
  border-color: #f5f5f5;
  border-style: solid;
}

.footer-nav-row {
  height: 100%;
  align-items: center;
}

.footer-nav-item {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  flex: 1 1 0;
  min-width: 0;
}

.footer-nav-item .v-row {
  width: 100%;
}


.mobile-menu-button {
  position: fixed;
  top: 0;
  z-index: 2;
  border-radius: 0 0 40px 40px;
}

.mobile-menu-icon {
  animation-name: dorak-menu-icon;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
}

@keyframes dorak-menu-icon {
  0% {
    transform: rotate(-1deg);
    margin-top: -5px
  }
  50% {
    transform: rotate(1deg);
    margin-top: 10px
  }
  100% {
    transform: rotate(-1deg);
    margin-top: -5px
  }
}

.down-menu-active {
  color: #1ab69d;
  background-color: #2fe3c6 !important;

}

.dorakk-footer-home-logo-mobile {
  display: table;
  margin: auto;
}

.custom-padding-navbar {
  padding: 1vh 8vw 1vh 8vw !important;
}

.stick-top-menu {

}

.custom-animation-navbar-middle:hover {
  color: #128572;
  transform: rotate(45deg);
  cursor: pointer;
}

.custom-animation-navbar:hover {
  color: #128572;
  transform: rotate(-45deg);
  cursor: pointer;
}

.title-dashboard-sections {
  font-size: 3.1vw !important;
  color: white !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  font-weight: 800 !important;
  line-height: 2rem !important;
}

.navigation-main {
  overflow-x: hidden !important;
  background: #1ab69d;
  background: radial-gradient(circle, #128572 1%, #1ab69d 100%);
}

.v-btn__content {
  font-family: Yekan2 !important;
}

.side-bar-items {
  font-family: Yekan2;
  font-size: 18px;
  font-weight: 800;
  color: white;
}

.side-bar-item {
  font-family: Yekan2;
  font-size: 16px;
  color: #110f58;
}

.icon-item {
  border-radius: 100px !important;
}

.empty-space {
  height: 300px;
}
</style>
